import React from "react";
import Wrapper from "../../Components/Wrapper/wrapper";
import { Pageheader } from "../../Constants/pageheader";
import { SchoolPricesNavigationHeader } from "../../Constants/Enums/navigationHeader.enum";
import { LunchPackages } from "../../Components/schoolPrices/lunchPackages/LunchPackages";
import { useLocation } from "react-router-dom";
import { AcademicPrices } from "../../Components/schoolPrices/academicPrices/AcademicPrices";

export const SchoolPrices = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const section = searchParams.get("section");

  return (
    <Wrapper
      header={Pageheader.SchoolPrices}
      headerNavigation={[
        {
          text: "Academic price",
          section: SchoolPricesNavigationHeader.ACADEMIC_PRICE,
        },
        {
          text: "Lunch packages",
          section: SchoolPricesNavigationHeader.LUNCH_PACKAGES,
        },
      ]}
    >
      {section === SchoolPricesNavigationHeader.ACADEMIC_PRICE ? (
        <AcademicPrices />
      ) : (
        <></>
      )}

      {section === SchoolPricesNavigationHeader.LUNCH_PACKAGES ? (
        <LunchPackages />
      ) : (
        <></>
      )}
    </Wrapper>
  );
};
